import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

type PartnerGuardProps = {
  children: React.ReactNode;
};

export default function PartnerGuard({ children }: PartnerGuardProps) {
  const location = useLocation();
  const partnerAuth = useSelector((state: RootState) => state.partnerAuth);

  if (!partnerAuth.accessToken) {
    return <Navigate to="/partner/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
